// extracted by mini-css-extract-plugin
export default {"icon":"iconWrapper_icon__Do1-u","iconXs":"iconWrapper_iconXs__GJsy6","iconSm":"iconWrapper_iconSm__8eOBu","iconMd":"iconWrapper_iconMd__qYKlv","iconLg":"iconWrapper_iconLg__4Ycfr"};